import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

export default new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: 'UNION',
          name: 'StorageSettingUnion',
          possibleTypes: [
            {
              name: 'StorageSetting',
            },
            {
              name: 'StorageInstanceSetting',
            },
          ],
        },
        {
          kind: 'UNION',
          name: 'NewUploadResponse',
          possibleTypes: [
            {
              name: 'NewUploadInfo',
            },
            {
              name: 'UploadOperationError',
            },
          ],
        },
        {
          kind: 'UNION',
          name: 'UploadConfig',
          possibleTypes: [
            {
              name: 'AppUploadConfig',
            },
            {
              name: 'AWSUploadConfig',
            },
          ],
        },
        {
          kind: 'UNION',
          name: 'CommitUploadResponse',
          possibleTypes: [
            {
              name: 'UploadedFileInfo',
            },
            {
              name: 'UploadOperationError',
            },
          ],
        },
        {
          kind: 'UNION',
          name: 'OperationResult',
          possibleTypes: [
            {
              name: 'UploadOperationError',
            },
            {
              name: 'UploadOperationSuccess',
            },
          ],
        },
        {
          kind: 'UNION',
          name: 'OrgStructureUnion',
          possibleTypes: [
            { name: 'RoleXOrgLevel' },
            { name: 'OrgStructureLevel' },
          ],
        },
        {
          kind: 'UNION',
          name: 'RoleOrgStructureUnion',
          possibleTypes: [
            { name: 'Organisation' },
            { name: 'RoleOrganisationStructure' },
            { name: 'RoleXOrgLevel' },
            { name: 'OrgStructureLevel' },
          ],
        },
        {
          kind: 'UNION',
          name: 'RoleOrgStructureUnionSelector',
          possibleTypes: [
            { name: 'Organisation' },
            { name: 'RoleOrganisationStructure' },
            { name: 'OrgStructureLevel' },
          ],
        },
        {
          kind: 'UNION',
          name: 'ProgramStructureUnion',
          possibleTypes: [
            { name: 'ProgramStructureSubject' },
            { name: 'ProgramStructureFolder' },
            { name: 'Program' },
            { name: 'ProgramFolder' },
            { name: 'ProgramGroup' },
          ],
        },
        {
          kind: 'UNION',
          name: 'ProgramsUnion',
          possibleTypes: [{ name: 'ProgramFolder' }, { name: 'Program' }],
        },
        {
          kind: 'UNION',
          name: 'LearningPlansUnion',
          possibleTypes: [
            { name: 'ProgramFolder' },
            { name: 'Program' },
            { name: 'ProgramStructureSubject' },
            { name: 'LearningPlan' },
          ],
        },
        {
          kind: 'UNION',
          name: 'ProgramIntakeStructureUnion',
          possibleTypes: [
            { name: 'Class' },
            { name: 'StudentGroup' },
            { name: 'IntakeProgramXSubject' },
            { name: 'IntakeXProgram' },
            { name: 'SubjectsSyntheticParent' },
            { name: 'StudentGroupSyntheticParent' },
            { name: 'OrgStructureLevel' },
          ],
        },
        {
          kind: 'UNION',
          name: 'PersonEntityAllocationRolesTreeUnion',
          possibleTypes: [
            { name: 'PersonEntityAllocationRole' },
            { name: 'Organisation' },
            { name: 'PersonEntityAllocationOrgStructLevel' },
          ],
        },
        {
          kind: 'UNION',
          name: 'OrganisationStructureGroupTreeUnion',
          possibleTypes: [
            { name: 'OrganisationStructureGroup' },
            { name: 'OrgStructureLevel' },
          ],
        },
      ],
    },
  },
});
